import { Skeleton, Stack } from '@ethings/ui-toolkit';
import { FC } from 'react';
import { TripCardSkeleton } from './trip-card-skeleton';

export const TripListSkeleton: FC = () => (
  <Stack spacing={1.5} style={{ paddingRight: 4 }}>
    <Stack alignItems="center" direction="row" justifyContent="space-between" spacing={1}>
      <Stack alignItems="center" direction="row" spacing={1}>
        <Skeleton height={32} variant="circular" width={32} />
        <Skeleton height={22} variant="text" width={80} />
      </Stack>
      <Skeleton height={22} variant="text" width={56} />
    </Stack>
    <TripCardSkeleton />
    <TripCardSkeleton />
    <TripCardSkeleton />
  </Stack>
);
